// ponytail: one listener per carousel; scrolls one card width
(function () {
  document.querySelectorAll('[data-shop-cats]').forEach((root) => {
    const track = root.querySelector('[data-shop-cats-track]');
    const prev = root.querySelector('[data-shop-cats-prev]');
    const next = root.querySelector('[data-shop-cats-next]');
    if (!track) return;

    const step = () => {
      const card = track.querySelector('.es-shop-cats__card');
      if (!card) return 200;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });
})();
